import { capitalise } from "./utils";

// React automatically sets NODE_ENV in test, start (development) and build (production)...
export const __TEST__ = process.env.NODE_ENV === "test";

// ...therefore custom REACT_APP_ENV variables are set in .env files
export const __DEV__ = process.env.REACT_APP_ENV === "development"; // localhost + dev-app
export const __PRODUCTION__ = process.env.REACT_APP_ENV === "production";

// Hostname dependant
export const __LOCAL__ = window.location.hostname === "localhost";
export const __DEV_APP__ = window.location.hostname === "dev-ch.happylegal.de";

export const __USER__ = localStorage.getItem("user")?.split("@")[0] ?? "";

const names = __USER__.split("@")[0].split(".");
export const __FIRST_NAME__ = capitalise(names?.[0]);
export const __LAST_NAME__ = capitalise(names?.[1]);

export const errorMessage = "Fehler! Bitte kontaktieren Sie die IT-Abteilung.";

/**
 * Query param the top bar sets to ask the Mietrechtsanfragen route to
 * open its "new case" dialog. The dialog needs that route's
 * CaseProvider, so the trigger and the dialog live apart.
 */
export const NEW_CASE_PARAM = "neuerFall";
